import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useState } from "react";
import { deleteUsuario, type Usuario } from "../../firebase/firestore/usuarios";
import { useUsuariosStore } from "../../zustand/useUsuariosStore";
import Modal from "./Modal";

interface ModalDeleteUserProps {
  isOpen: boolean;
  onClose: () => void;
  usuario?: Usuario;
}

export default function ModalDeleteUser({
  isOpen,
  onClose,
  usuario,
}: ModalDeleteUserProps) {
  const { fetchAllUsuarios, resetUsuarios } = useUsuariosStore();
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    if (!usuario || isLoading) return;

    setIsLoading(true);
    try {
      await deleteUsuario(usuario.id);
      onClose();
      resetUsuarios();
      await fetchAllUsuarios();
    } catch (error) {
      console.error("Error eliminando usuario:", error);
      // El toast de error ya se muestra en deleteUsuario
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      disableBackdropClick={isLoading}
      title="Eliminar usuario"
      content={
        <Box
          sx={{
            paddingX: "24px",
            marginBottom: 2,
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Typography>
            {usuario
              ? `El usuario "${usuario.name} ${usuario.lastName}" (${usuario.email}) será eliminado permanentemente. ¿Estás seguro que deseas continuar?`
              : "¿Estás seguro que deseas eliminar este usuario?"}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button 
              onClick={handleClose} 
              variant="outlined" 
              size="small"
              disabled={isLoading}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleDelete}
              variant="contained"
              color="error"
              size="small"
              disabled={isLoading}
              startIcon={isLoading ? <CircularProgress size={16} /> : null}
            >
              {isLoading ? "Eliminando..." : "Eliminar"}
            </Button>
          </Box>
        </Box>
      }
      sx={{
        marginX: "auto",
        width: {
          xs: "90%",
          sm: "50%",
        },
      }}
    />
  );
}
